/** @jsx jsx */

import { css, jsx } from '@emotion/react';

const DividerStyles = css({
  borderTop: `1px solid var(--zds-stroke-weaker, #D7D3C9)`,
  margin: 'var(--zds-space-12, 12px) 0',
});

export const Divider = () => <hr css={DividerStyles} data-zds />;
